/* eslint-disable react-hooks/exhaustive-deps */
import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useCallback, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import foto1 from '../../assets/foto1.png'
import foto2 from '../../assets/foto2.png'
import foto3 from '../../assets/foto3.png'
import search from '../../assets/search.svg'
import search2 from '../../assets/search2.svg' 
import back from '../../assets/back.svg' 
import pin from '../../assets/pin-1.svg' 
import sort from '../../assets/options.svg'
import { ListChefCard } from '../Card/ListChefCard/ListChefCard';
import { useNavigate } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import spinner from '../../assets/spinner.gif'
import axios from 'axios'
import { baseUrl } from '../../lib/api'

export const ChefListPage = () => {
    const history = useNavigate()
    const listCategory = []
    const listLocation = []
    const [listLocationFound, setListLocationFound] = useState([])
    const [listCategoryFound, setListCategoryFound] = useState([])
    const [category, setCategory] = useState([])
    const [filterChef, setFilterChef] = useState('')
    const [filterLocation, setFilterLocation] = useState('Location')
    const [showSortBy, setShowSortBy] = useState(false)
    const [sortBy, setSortBy] = useState('Sort by')
    const [showFilterLocation, setShowFilterLocation] = useState(false)
    const [filterSearchLocation, setFilterSearchLocation] = useState('')
    const [databaseLocation, setDatabaseLocation] = useState([])
    const [showSearchMobile, setShowSearchMobile] = useState(false)
    const [showSortByMobile, setShowSortByMobile] = useState(false)
    const [standby, setstandby] = useState(true)
    const firstUpdate = useRef(true);
    const [loading, setLoading] = useState(true)
    const [showNavPopup, setShowNavPopup] = useState(false)

    const handleCloseAll = () => {
        setShowFilterLocation(false)
        setShowSearchMobile(false)
        setShowSortBy(false)
        setShowNavPopup(false)
        setShowSortByMobile(false)
    }

    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true) 
        const categoryChefFromDB = async (params) => {
            try {
                /*
                Params is array of object
                [
                    {
                        "location": "Lake Cel"
                    },
                    {
                        "genre": "indonesian"
                    }
                ]
                */
                const data = await callApigetCategoryChef(params)
                // Create parser before set to state
                // setCategory(data)
            } catch (error) {
                console.log("Error categoryChefFromDB")
            }
        }
        // Turn on to use it
        // const params = [
        //     {
        //         "location": "Lake Cel"
        //     },
        //     {
        //         "genre": "indonesian"
        //     }
        // ]
        // categoryChefFromDB(params)
        
        setCategory([{gambar:foto1,nama:"Adrian Judarta",jenis:["Asian", "Western"],area:"Jakarta",harga:150,rating:4.5},
                    {gambar:foto2,nama:"Mufalando",jenis:["Asian", "Indonesian"],area:"Yogyakarta",harga:200,rating:4.5},
                    {gambar:foto3,nama:"Brian",jenis:["Indian"],area:"Bandung",harga:250,rating:4.5},
                    {gambar:foto2,nama:"Hanrichie",jenis:["Western", "Indian"],area:"Jakarta",harga:100,rating:4.5},
                    {gambar:foto1,nama:"Adrian Judarta",jenis:["Asian", "Western"],area:"Semarang",harga:150,rating:4.5},
                    {gambar:foto2,nama:"Mufalando",jenis:["Asian", "Indonesian"],area:"Tangerang",harga:200,rating:4.5},
                    {gambar:foto3,nama:"Brian",jenis:["Indian"],area:"Jakarta",harga:250,rating:4.5},
                    {gambar:foto2,nama:"Hanrichie",jenis:["Western", "Indian"],area:"Jakarta",harga:100,rating:4.5},
                    {gambar:foto1,nama:"Adrian Judarta",jenis:["Asian", "Western"],area:"Jakarta",harga:150,rating:4.5},
                    {gambar:foto2,nama:"Mufalando",jenis:["Asian", "Indonesian"],area:"Jakarta",harga:200,rating:4.5},
                    {gambar:foto3,nama:"Brian",jenis:["Indian"],area:"Jakarta",harga:250,rating:4.5},
                    {gambar:foto2,nama:"Hanrichie",jenis:["Western", "Indian"],area:"Jakarta",harga:100,rating:4.5},
                    {gambar:foto1,nama:"Adrian Judarta",jenis:["Asian", "Western"],area:"Jakarta",harga:150,rating:4.5},
                    {gambar:foto2,nama:"Mufalando",jenis:["Asian", "Indonesian"],area:"Jakarta",harga:200,rating:4.5},
                    {gambar:foto3,nama:"Brian",jenis:["Indian"],area:"Jakarta",harga:250,rating:4.5},
                    {gambar:foto2,nama:"Hanrichie",jenis:["Western", "Indian"],area:"Jakarta",harga:100,rating:4.5},
                    {gambar:foto1,nama:"Adrian Judarta",jenis:["Asian", "Western"],area:"Jakarta",harga:150,rating:4.5},
                    {gambar:foto2,nama:"Mufalando",jenis:["Asian", "Indonesian"],area:"Jakarta",harga:200,rating:4.5},
                    {gambar:foto3,nama:"Brian",jenis:["Indian"],area:"Jakarta",harga:250,rating:4.5},
                    {gambar:foto2,nama:"Hanrichie",jenis:["Western", "Indian"],area:"Jakarta",harga:100,rating:4.5}
                    ])
        localStorage.setItem('nav', 'fnd')
        localStorage.setItem('categoryList','')
    },[])

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else{
            setLoading(false)
        }
    },[category])

    useEffect(() =>{
        for(var x in category){
            for(var y in category[x].jenis){
                if(!listCategory.includes(category[x].jenis[y])){
                    listCategory.push(category[x].jenis[y])
                }
            }if(!listLocation.includes(category[x].area)){
                listLocation.push(category[x].area)
            }
        }

        setListLocationFound(listLocation)
        setDatabaseLocation(listLocation)
        setListCategoryFound(listCategory)
        localStorage.setItem('categoryList',listCategory[0])
    },[category])

    const handleListCategory = (e) => {
        var y = document.getElementById(localStorage.getItem('categoryList'))
        localStorage.setItem('categoryList',e)
        var x = document.getElementById(e)
        x.className = "categorylist underline"
        y.className = "categorylist"
    }

    const handleSortBy = (e) => {
        // // based on dummy data, it goes like this
        // Default will be acending
        let sortedCategory = category.sort((a, b) => a.harga - b.harga)
        if (e === "Lowest IDR - Highest IDR") {
            sortedCategory = category.sort((a, b) => b.harga - a.harga)
        }
        setCategory(sortedCategory)
        setShowSortBy(false)
        setShowSortByMobile(false)
        setSortBy(e)
    }

    const handleFilterLocation = (e) => {
        setShowFilterLocation(false)
        setFilterLocation(e)
    }

    const handleShowFilter = (e) => {
        if(e === 'location'){
            showFilterLocation? setShowFilterLocation(false):setShowFilterLocation(true)
            setShowSortBy(false)
        }else{
            showSortBy? setShowSortBy(false):setShowSortBy(true)
            setShowFilterLocation(false)
        }
    }

    const handleSearchLocation = (e) => {
        setFilterSearchLocation(e);
        const foundLocation = []
        for (var x in databaseLocation){
          if (databaseLocation[x].toLowerCase().includes(e.toLowerCase())){
            foundLocation.push(databaseLocation[x])
          }
        }
        setListLocationFound(foundLocation);
    }

    const [y, setY] = useState(window.scrollY);

    const handleOpenSearchBar = () => {
        setShowSearchMobile(true)
        setShowSortByMobile(false)
    }

    const handleNavigation = useCallback(
        e => {
          const window = e.currentTarget;
          setY(window.scrollY);
          if(y<=50){
            var elem = document.getElementById("penggantidiubah");
            elem.style.transition = "background-color 0.5s";
            elem.style.backgroundColor = "transparent";
        }else{
            var elem2 = document.getElementById("penggantidiubah");
            elem2.style.transition = "background-color 0.5s";
            elem2.style.backgroundColor = "rgba(0, 0, 0, 1)";
            }
        }, [y]
      );

    useEffect(() => {
    setY(window.scrollY);
    window.addEventListener("scroll", handleNavigation);
    
    return () => {
        window.removeEventListener("scroll", handleNavigation);
    };
    }, [handleNavigation]);

    const parseCategoryChef = (categoryChefData) => {
        categoryChefData = categoryChefData.map((el) => {
            return {
                id: el.id,
                cover_image: el.cover_image,
                full_name: el.full_name,
                rating: el.rating,
                genres: el.genres,
                address: el.address,
                starting_price: el.starting_price,
            }
        })
        return categoryChefData
    }

    const handleParamsAPI = (params) => {
        let parsedParams = {}
        for (let value of params) {
            parsedParams = {...parsedParams, ...value}
        }
        return parsedParams
    }

    const callApigetCategoryChef = async (params) => {
        try {
            let paramsToBePassed = null
            if (params) {
                paramsToBePassed = handleParamsAPI(params)
            }
            const { data: res } = await axios({
                method: 'get',
                url: `${baseUrl}category/type/chef`,
                params: paramsToBePassed
            })
            const categoryChefData = res.data
            const parsedCategoryChef = parseCategoryChef(categoryChefData)
            return parsedCategoryChef
        } catch (error) {
            console.log("error getCategoryChefFromDB")
            // Create error handler (pop-up or something)
        }
    }

    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <div className='kontainerPenggantiNavbar' id="penggantidiubah">
            {
                showSearchMobile ?
                <div onClick={e => {e.preventDefault();e.stopPropagation();}} className='searchbarmobilekontainer'>
                    <div className='searchbarmobile'>
                        <img src={search2} alt="iconback" className='iconKiriSerMo'></img>
                        <input value={filterChef} onChange={e => setFilterChef(e.target.value)} className="fieldchef" type='text' placeholder='Search by Chef or Cuisine' style={{marginLeft:"20px", marginRight:"20px"}}/>
                        <img onClick={e => {e.preventDefault();e.stopPropagation();setShowSearchMobile(false)}} src={back} alt="iconback" className='iconKananSerMo'></img>
                    </div>
                </div>
                :
                <div className='PenggantiNavbar'>
                    <img onClick={e => {e.preventDefault();e.stopPropagation();history(-1)}} src={back} alt="iconback" className='iconKiriNavMo'></img>
                    <img onClick={e => {e.preventDefault();e.stopPropagation();handleOpenSearchBar()}} src={search2} alt="iconback" className='iconKananNavMo'></img>
                    <img onClick={e => {e.preventDefault();e.stopPropagation();showSortByMobile? setShowSortByMobile(false):setShowSortByMobile(true)}} src={sort} alt="iconback" style={{marginRight:"20px"}} className='iconKiriNavMo'></img>
                    {
                        showSortByMobile === true && (
                            <div className="popupkontainerlistchefmobile">
                                <div style={{postion:"relative", height:"100%", width:"100%"}}>
                                    <p onClick={e => {e.preventDefault();e.stopPropagation();handleSortBy('Highest IDR - Lowest IDR')}} className="popupfontlistchef">Highest IDR - Lowest IDR</p>
                                    <p className="popupfontlistchef" onClick={e => {e.preventDefault();e.stopPropagation();handleSortBy('Lowest IDR - Highest IDR')}}>Lowest IDR - Highest IDR</p>
                                </div>
                            </div>
                        )
                    }
                </div>  
            }
            </div>

            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="CLtrans">
                <div>
                <div className='headerkontainer'>
                    <div className='kontainercategorycuisine'>
                    {listCategoryFound.map((post) => {
                        if(post === listCategoryFound[0]){
                            return (
                                <p onClick={e => {handleListCategory(post)}} style={{paddingTop:"0"}} id={post} className='categorylist underline'>{post}</p>
                                )
                        }else{
                            return (
                                <p onClick={e => {handleListCategory(post)}} style={{paddingTop:"0"}} id={post} className='categorylist'>{post}</p>
                                )
                        }
                    })}
                    </div>
                    <div onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll()}} id="wrappernya" className="findchef">
                        <img src={search} alt='icon' className="iconsearch"></img>
                        <input id="fieldnya" value={filterChef} onChange={e => setFilterChef(e.target.value)} className="fieldchef" type='text' placeholder='Search by Chef or Cuisine'/>
                    </div>

                    <div className='containerfilterchef'>
                        {
                            showFilterLocation?
                            <div onClick={e => {e.preventDefault();e.stopPropagation();handleShowFilter('location')}} className="filterchef LCyellow">
                                <img src={pin} alt='icon' className="iconsearch"></img>
                                <p className='filterchoice'>{filterLocation}</p>
                            </div>
                            :
                            <div onClick={e => {e.preventDefault();e.stopPropagation();handleShowFilter('location')}} className="filterchef">
                                <img src={pin} alt='icon' className="iconsearch"></img>
                                <p className='filterchoice'>{filterLocation}</p>
                            </div>
                        }

                        {
                            showFilterLocation === true && (
                                <div className="popupkontainerlistchef" style={{marginRight:"0"}}>
                                    <div style={{postion:"relative", height:"100%", width:"100%"}}>
                                        <div onClick={e => {e.preventDefault();e.stopPropagation();}} className="inputfind">
                                            <img src={search} alt='icon' className="iconsearch"></img>
                                            <input value={filterSearchLocation} onChange={e => handleSearchLocation(e.target.value)} className="fieldlocation" type='text' placeholder='Search Location'/>
                                        </div>
                                        {listLocationFound.map((post) => (
                                            <p className="popupfontlistchef" onClick={e => {e.preventDefault();e.stopPropagation();handleFilterLocation(post)}}>{post}</p>
                                        ))}
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    
                    <div className='containerfilterchef'>
                        {
                            showSortBy?
                            <div onClick={e => {e.preventDefault();e.stopPropagation();handleShowFilter('sortBy')}} className="filterchef LCyellow" style={{marginRight:"20px"}}>
                                <img src={sort} alt='icon' className="iconsearch"></img>
                                <p className='filterchoice2'>{sortBy}</p>
                            </div>
                            :
                            <div onClick={e => {e.preventDefault();e.stopPropagation();handleShowFilter('sortBy')}} className="filterchef" style={{marginRight:"20px"}}>
                                <img src={sort} alt='icon' className="iconsearch"></img>
                                <p className='filterchoice2'>{sortBy}</p>
                            </div>
                        }
                        
                        {
                            showSortBy === true && (
                                <div className="popupkontainerlistchef">
                                    <div style={{postion:"relative", height:"100%", width:"100%"}}>
                                        <p onClick={e => {e.preventDefault();e.stopPropagation();handleSortBy('Highest IDR - Lowest IDR')}} className="popupfontlistchef">Highest IDR - Lowest IDR</p>
                                        <p className="popupfontlistchef" onClick={e => {e.preventDefault();e.stopPropagation();handleSortBy('Lowest IDR - Highest IDR')}}>Lowest IDR - Highest IDR</p>
                                    </div>
                                </div>
                            )
                        }
                    </div>

                </div>
                <div className='ListChefPageCardContainer'>
                    {category.map((post) => (
                        <ListChefCard
                            data={post} standby={standby} fungsi={()=>setstandby(false)}
                        />
                        ))}
                </div>
                </div>
                </CSSTransition>
        }
        </div>
    )
  }